import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=5df49d7e&"
import script from "./Barrage.vue?vue&type=script&lang=js&"
export * from "./Barrage.vue?vue&type=script&lang=js&"
import style0 from "./Barrage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Barrage.vue"
export default component.exports